module.exports = __webpack_public_path__ + "img/close.d85adae6.svg";